export default __webpack_public_path__ + "static/mix-blend-mode-f38795b89007a58fd2e400e5edc9200d.gif";